// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `mat-drawer {
  width: 250px;
}
.sidebar-header {
  padding: 20px;
  background: #fff;
}

.user-avtar {
  border-radius: 50%;
  width: 66px;
}

.mat-drawer-content {
  background-color: #dfe7ed;
}

.mat-drawer-container {
  overflow: visible;
  position: absolute;
  left: 0;
  right: 0;
}

.mat-list-item {
  height: 60px !important;
}

.material-icons {
  margin-right: 10px;
}

.menu-svg-icon {
  width: 24px;
  height: 24px;
  margin-right: 10px;
}

::ng-deep .mat-icon-button {
  font-weight: 400 !important;
}

::ng-deep .tree-parent-node button.expanded-active {
  color: #da512d !important;
}

::ng-deep .tree-parent-node button.expanded-active mat-icon {
  color: #da512d !important;
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImxlZnQtbWVudS5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsWUFBWTtBQUNkO0FBQ0E7RUFDRSxhQUFhO0VBQ2IsZ0JBQWdCO0FBQ2xCOztBQUVBO0VBQ0Usa0JBQWtCO0VBQ2xCLFdBQVc7QUFDYjs7QUFFQTtFQUNFLHlCQUF5QjtBQUMzQjs7QUFFQTtFQUNFLGlCQUFpQjtFQUNqQixrQkFBa0I7RUFDbEIsT0FBTztFQUNQLFFBQVE7QUFDVjs7QUFFQTtFQUNFLHVCQUF1QjtBQUN6Qjs7QUFFQTtFQUNFLGtCQUFrQjtBQUNwQjs7QUFFQTtFQUNFLFdBQVc7RUFDWCxZQUFZO0VBQ1osa0JBQWtCO0FBQ3BCOztBQUVBO0VBQ0UsMkJBQTJCO0FBQzdCOztBQUVBO0VBQ0UseUJBQXlCO0FBQzNCOztBQUVBO0VBQ0UseUJBQXlCO0FBQzNCIiwiZmlsZSI6ImxlZnQtbWVudS5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsibWF0LWRyYXdlciB7XG4gIHdpZHRoOiAyNTBweDtcbn1cbi5zaWRlYmFyLWhlYWRlciB7XG4gIHBhZGRpbmc6IDIwcHg7XG4gIGJhY2tncm91bmQ6ICNmZmY7XG59XG5cbi51c2VyLWF2dGFyIHtcbiAgYm9yZGVyLXJhZGl1czogNTAlO1xuICB3aWR0aDogNjZweDtcbn1cblxuLm1hdC1kcmF3ZXItY29udGVudCB7XG4gIGJhY2tncm91bmQtY29sb3I6ICNkZmU3ZWQ7XG59XG5cbi5tYXQtZHJhd2VyLWNvbnRhaW5lciB7XG4gIG92ZXJmbG93OiB2aXNpYmxlO1xuICBwb3NpdGlvbjogYWJzb2x1dGU7XG4gIGxlZnQ6IDA7XG4gIHJpZ2h0OiAwO1xufVxuXG4ubWF0LWxpc3QtaXRlbSB7XG4gIGhlaWdodDogNjBweCAhaW1wb3J0YW50O1xufVxuXG4ubWF0ZXJpYWwtaWNvbnMge1xuICBtYXJnaW4tcmlnaHQ6IDEwcHg7XG59XG5cbi5tZW51LXN2Zy1pY29uIHtcbiAgd2lkdGg6IDI0cHg7XG4gIGhlaWdodDogMjRweDtcbiAgbWFyZ2luLXJpZ2h0OiAxMHB4O1xufVxuXG46Om5nLWRlZXAgLm1hdC1pY29uLWJ1dHRvbiB7XG4gIGZvbnQtd2VpZ2h0OiA0MDAgIWltcG9ydGFudDtcbn1cblxuOjpuZy1kZWVwIC50cmVlLXBhcmVudC1ub2RlIGJ1dHRvbi5leHBhbmRlZC1hY3RpdmUge1xuICBjb2xvcjogI2RhNTEyZCAhaW1wb3J0YW50O1xufVxuXG46Om5nLWRlZXAgLnRyZWUtcGFyZW50LW5vZGUgYnV0dG9uLmV4cGFuZGVkLWFjdGl2ZSBtYXQtaWNvbiB7XG4gIGNvbG9yOiAjZGE1MTJkICFpbXBvcnRhbnQ7XG59XG4iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/left-menu/left-menu.component.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,4nDAA4nD","sourcesContent":["mat-drawer {\n  width: 250px;\n}\n.sidebar-header {\n  padding: 20px;\n  background: #fff;\n}\n\n.user-avtar {\n  border-radius: 50%;\n  width: 66px;\n}\n\n.mat-drawer-content {\n  background-color: #dfe7ed;\n}\n\n.mat-drawer-container {\n  overflow: visible;\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n\n.mat-list-item {\n  height: 60px !important;\n}\n\n.material-icons {\n  margin-right: 10px;\n}\n\n.menu-svg-icon {\n  width: 24px;\n  height: 24px;\n  margin-right: 10px;\n}\n\n::ng-deep .mat-icon-button {\n  font-weight: 400 !important;\n}\n\n::ng-deep .tree-parent-node button.expanded-active {\n  color: #da512d !important;\n}\n\n::ng-deep .tree-parent-node button.expanded-active mat-icon {\n  color: #da512d !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
